import { APButton } from '@astropay/web-core-library';
import { makeStyles, Theme } from '@material-ui/core';

import { translate } from 'common/config/i18n';

const useStyles = makeStyles((theme: Theme) => ({
  backContainer: {
    marginRight: theme.spacing(1),
    maxWidth: 'min-content',
    minWidth: 'max-content',
    '& > * ': {
      color: theme.colors.Text_Primary,
    },
  },
}));

interface backActionProps {
  goBackAction: () => void;
}

const BackAction: React.FC<backActionProps> = (props) => {
  const { goBackAction } = props;
  const classes = useStyles();
  return (
    <APButton
      textStyle="Typography_Poppins_12px_SemiBold"
      variant="text"
      icon={['far', 'arrow-left']}
      iconPosition="icon-left"
      iconSize="xs"
      size="small"
      id="btn-back-action"
      text={translate('deposit_back')}
      className={classes.backContainer}
      onClick={goBackAction}
    ></APButton>
  );
};

export default BackAction;
